module.exports = __webpack_public_path__ + "images/homepage-tick.png";


//////////////////
// WEBPACK FOOTER
// ./homepage/images/homepage-tick.png
// module id = 849
// module chunks = 0